export const getCostFromCurrencyString = (string) => {
    return parseFloat(string.replace(/[^\d.]/g, ""));

}